<form [formGroup]="formGroupValue">
  <ion-row class="from-to-date-container">
    <!-- From Date -->
    <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
      <div>
        <span>{{ CONSTS.FROM_LABEL }}</span>
      </div>
      <app-form-date-picker
        class="report-date-picker"
        [minDate]="customMinFromDate ? customMinFromDate : minDate"
        [maxDate]="customMaxFromDate ? customMaxFromDate : maxDate"
        [formControlName]="fromControl"
        [icon]="SRC.CALENDAR"
        (valueChange)="updateValue()"
      ></app-form-date-picker>
    </ion-col>

    <!-- To Date -->
    <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
      <div>
        <span>{{ CONSTS.TO_LABEL }}</span>
      </div>
      <app-form-date-picker
        class="report-date-picker"
        [minDate]="customMinToDate ? customMinToDate : minDate"
        [maxDate]="customMaxToDate ? customMaxToDate : maxDate"
        [formControlName]="toControl"
        [icon]="SRC.CALENDAR"
        (valueChange)="updateValue()"
      ></app-form-date-picker>
    </ion-col>
  </ion-row>
  @if (hasDateError) {
    <ion-row size="6">
      <span class="date-error">
        {{ CONSTS.DATE_ERROR }}
      </span>
    </ion-row>
  }
</form>
